import styled from '@emotion/styled';
import { Button } from '$shared/components';
import { breakpoints } from '~/theme';
import { scrollbarThin } from '~/shared/utils/styled/scrollbar';

export const StyledCategoriesFiltersContainer = styled.div({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
});

export const StyledCategoriesFiltersContent = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spaces[2],
}));

export const StyledResultsListWrapper = styled.div(() => ({
    position: 'relative',
    display: 'flex',
    overflowX: 'auto',
}));

export const StyledDynamicFiltersWrapper = styled.div(() => ({
    display: 'flex',
    marginLeft: 'auto',
    [breakpoints.md]: {
        display: 'none',
    },
}));

export const StyledResultsList = styled.ul(({ theme }) => ({
    display: 'flex',
    overflowX: 'auto',
    gap: theme.spaces[1],
    paddingRight: theme.spaces[4],
    paddingTop: theme.spaces[2],
    paddingBottom: theme.spaces[2],
    ...scrollbarThin,
    [breakpoints.md]: {
        flexDirection: 'column',
    },
}));

export const StyledResultsListShadow = styled.div(({ theme }) => ({
    position: 'absolute',
    top: '0',
    right: '0',
    zIndex: 2,
    display: 'block',
    width: theme.spaces[4],
    height: '100%',
    pointerEvents: 'none',
    backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1))',
}));

export const StyledResultsItem = styled(Button)(({ theme }) => ({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre',
    ['mark']: {
        fontWeight: theme.fontWeights.medium,
        backgroundColor: 'transparent',
        [breakpoints.md]: {
            fontWeight: theme.fontWeights.bold,
        },
    },
}));

export const StyledResultsItemDesktop = styled(Button)(({ theme }) => ({
    padding: `${theme.spaces[2]} ${theme.spaces[3]}`,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.borders.radius,
    fontSize: theme.fontSizes.md,
    whiteSpace: 'pre',
    border: 'none',
    justifyContent: 'flex-start',
    lineHeight: theme.lineHeights.base,
    ['mark']: {
        fontWeight: theme.fontWeights.medium,
        backgroundColor: 'transparent',
        [breakpoints.md]: {
            fontWeight: theme.fontWeights.bold,
        },
    },
}));

export const StyledButtonRemove = styled.span(() => ({
    display: 'inline-flex',
}));

export const StyledResponsiveTriggersJustIcons = styled.div(() => ({
    display: 'flex',
}));

export const StyledResponsiveTriggersJustIconsButton = styled(Button)(({ theme }) => ({
    fontSize: theme.fontSizes.sm,
    textAlign: 'center',
    padding: theme.spaces[2],
    backgroundColor: theme.colors.light,
    color: theme.colors.dark70,
    svg: {
        fontSize: theme.fontSizes.sm,
    },
}));
